import React from 'react';

export default ({report}) => (
  <React.Fragment>
    Route: <strong>{report.route || 'Not Provided'}</strong><br />
    Route MDR: <strong>{report.routeMDR || 'Not Provided'}</strong><br />
    Route Phone: <strong>{report.routePhone || 'Not Provided'}</strong><br />
  </React.Fragment>
);


// WEBPACK FOOTER //
// ./src/views/report/report-header-route.js